import moment from "moment";
import {
  IconReport,
  IconSettings,
  IconTransactions,
  IconDashboard,
  IconClientInformation,
  IconWithdrawals,
  IconGlobalSearch,
  IconNixxeCrypto,
} from "../utils/icons";

export const changeStateOnDeleteAndEdit = (vars) => {
  var arr = [];
  var { array, key, value, key_for_change, mode, conditionValue } = vars;
  for (let i = 0; i < array.length; i++) {
    var row = { ...array[i] };
    if (Array.isArray(conditionValue)) {
      if (conditionValue?.includes(row[key])) {
        if (mode === "edit") {
          if (Array.isArray(key_for_change)) {
            for (var j = 0; j < key_for_change.length; j++) {
              row[key_for_change[j]] = value[j];
            }
          } else {
            row[key_for_change] = value;
          }
        } else if (mode === "delete") {
          continue;
        }
      }
    } else {
      if (row[key] === conditionValue) {
        if (mode === "edit") {
          if (Array.isArray(key_for_change)) {
            for (let j = 0; j < key_for_change.length; j++) {
              row[key_for_change[j]] = value[j];
            }
          } else {
            row[key_for_change] = value;
          }
        } else if (mode === "delete") {
          continue;
        }
      }
    }
    arr = [...arr, row];
  }
  return arr;
};

export const changeStateOnDeleteAndEditV2 = ({ array, key, value, key_for_change, mode, conditionValue }) => {
  let arr = [];

  if (mode === "insert") {
    arr = [value, ...array]; // insert new row at the top
    return arr;
  }

  for (let i = 0; i < array.length; i++) {
    let row = { ...array[i] };

    if (Array.isArray(conditionValue)) {
      // multiple matches allowed
      if (conditionValue.includes(row[key])) {
        if (mode === "edit") {
          if (Array.isArray(key_for_change)) {
            for (let j = 0; j < key_for_change.length; j++) {
              row[key_for_change[j]] = value[j];
            }
          } else {
            row[key_for_change] = value;
          }
        } else if (mode === "delete") {
          continue; // skip this row
        }
      }
    } else {
      // single match
      if (row[key] === conditionValue) {
        if (mode === "edit") {
          if (Array.isArray(key_for_change)) {
            for (let j = 0; j < key_for_change.length; j++) {
              row[key_for_change[j]] = value[j];
            }
          } else {
            row[key_for_change] = value;
          }
        } else if (mode === "delete") {
          continue; // skip this row
        }
      }
    }

    arr = [...arr, row];
  }

  return arr;
};

export const credentialsEnvironmentType = { prod: "PROD", dev: "DEV" };

export const convertDateTimeToLocale = (datetime, seconds = false) => {
  var utcFromDB = moment(datetime).utc().format("YYYY-MM-DD HH:mm:ss");
  var localTime = moment.utc(utcFromDB).toDate();
  let format = "YYYY-MM-DD HH:mm";
  if (seconds) {
    format = "YYYY-MM-DD HH:mm:ss";
  }
  localTime = moment(localTime).format(format);
  return localTime;
};
export const convertDateToUnix = (date) => {
  var utcFromDB = moment(date).format("YYYY-MM-DD HH:mm:ss");
  var localTime = moment.utc(utcFromDB).toDate();
  return moment(localTime).unix();
};

export const formatDob = (value) => {
  if (!value) return "";
  const m = moment(
    value,
    ["DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", moment.ISO_8601],
    true,
  );
  return m.isValid() ? m.format("DD/MM/YYYY") : value;
};
export const convertArrayToObj = (vars) => {
  let { arr, key } = vars;
  let obj = {};
  for (var i = 0; i < arr.length; i++) {
    obj[arr[i][key]] = arr[i];
  }
  return obj;
};
export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {};

    reader.onloadend = () => {
      return resolve(reader.result);
    };

    reader.onerror = (error) => reject(error);
  });
};

export const splitName = (value) => {
  let acronym = "";
  if (!value) return acronym;
  var matches = value.match(/\b(\w)/g) || [];
  acronym = matches.join("").slice(0, 2).toUpperCase();
  return acronym;
};

export const thousandSeperated = (number) => {
  return Number(number).toLocaleString("en", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const groupByKey = (array, key) => {
  return array.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, {
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    });
  }, {});
};
export const replaceMiddleWithDots = (str) => {
  // Calculate the start and end indexes of the middle half
  var len = str.length;
  let end = len - 8;

  var result = str.substring(0, 8) + "...." + str.substring(end, len);
  return result;
};
export const convertDateToUTC = (date) => {
  var utcFromDB = moment(date).format("YYYY-MM-DD HH:mm:ss");
  return utcFromDB;
};
export const convertDateTimeToLocaleV2 = (datetime) => {
  var utcFromDB = moment(datetime).utc().format("YYYY-MM-DD HH:mm:ss");
  var localTime = moment.utc(utcFromDB).toDate();
  localTime = moment(localTime).format("YYYY/MM/DD HH:mm");
  return localTime;
};
export const generateRandomString = (length) => {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result?.toLowerCase();
};
export const getIconForMainMenu = (iconType, active, isMobile) => {
  switch (iconType) {
    case "global_search":
      return <IconGlobalSearch isMobile={isMobile} active={active} />;
    case "transactionList":
      return <IconTransactions isMobile={isMobile} active={active} />;
    case "nixxe_crypto":
      return <IconNixxeCrypto isMobile={isMobile} active={active} />;
    case "request_withdrawal":
      return <IconWithdrawals isMobile={isMobile} active={active} />;
    case "user_bank_data":
      return <IconClientInformation isMobile={isMobile} active={active} />;
    case "reporting":
      return <IconReport isMobile={isMobile} active={active} />;
    case "settings":
      return <IconSettings isMobile={isMobile} active={active} />;
    case "dashboard":
      return <IconDashboard isMobile={isMobile} active={active} />;
    default:
      break;
  }
};
export const originalCopy = (obj) => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(originalCopy);
  }
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = originalCopy(obj[key]);
    return acc;
  }, {});
};
export const removeLocalStorageOnSignOut = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("client-id");
  localStorage.removeItem("email");
  localStorage.removeItem("selectedClients");
  localStorage.removeItem("support_grant");
  localStorage.removeItem("support_grant_expires_at");
};
export const isJSONString = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
};
export const formatString = (str, separator) => {
  if (!str) return "";
  return str.trim().replace(/ /g, separator);
};
export const copyToClipboard = (text, alert_notify, message = "Copied") => {
  if (text && String(text).length) {
    navigator.clipboard.writeText(String(text));
    alert_notify("success", message);
  }
};
export const convertDateToUTCV2 = (date) => {
  var utcFromDB = moment(date).utc().format("YYYY-MM-DD HH:mm:ss");
  return utcFromDB;
};
export const isDataURIComponent = (data) => {
  try {
    decodeURIComponent(data);
    return true;
  } catch (error) {
    return false;
  }
};
export const normalizeEmail = (email) => {
  return email.trim().toLowerCase();
};

export const s3_asset = process.env.REACT_APP_AWS_BASE_URL;
